import React from 'react';

import { FakturaList } from '@klp/faktura/components/FakturaList';

export const ByggFakturaList: React.FC = () => {
    return <FakturaList isByggFakturaView={true} />;
};
